function ScrollToTopCpn(){

    return (
        <>
            <div className="SingleBlog_scrollToTopDiv__Br1VC" onClick={()=>{
                                    window.scrollTo(0,0);
                                }}>
                                <div className="SingleBlog_circle__Lnz5m">
                                    <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth={0}
                                    viewBox="0 0 24 24"
                                    className="SingleBlog_scrollUpArrow__TuY2U"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                    >
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
                                    </svg>
                                </div>
            </div>
        </>
    )
}

export default ScrollToTopCpn;